// 物件写真のパス（frontend/public/img の画像を使う）
//   物件ID → 画像ファイル。新しい物件を追加したら、ここに1行足す。
const PROPERTY_IMAGES: Record<string, string> = {
  'prop-001': '/img/staydream.jpg',  // Stay Dream Hotel
  'prop-002': '/img/flowertea.jpg',  // Flower Tea Hotel
  'prop-003': '/img/greatview.jpg',  // Great View Stay
};

/** 物件の写真URL。登録がない物件は従来どおり API の画像を使う */
export function propertyImageUrl(propertyId: string): string {
  return PROPERTY_IMAGES[propertyId] || `/api/properties/${propertyId}/image`;
}
